// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCKEjxmR9TF7rBL2V1WmJibiR27znhOxd0",
  authDomain: "aishoppingcart.firebaseapp.com",
  projectId: "aishoppingcart",
  storageBucket: "aishoppingcart.firebasestorage.app",
  messagingSenderId: "994281853433",
  appId: "1:994281853433:web:4bcfb29a1b05ccd865ad28",
  measurementId: "G-74RCRE4EFF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

export { auth, db, googleProvider };
